import { assocPath, mergeDeepRight } from 'ramda'
import thunk from 'redux-thunk'
import { createReducer } from 'reduxsauce'

import FetchingMiddleware from '../services/FetchingMiddleware'
import type { TherapistStateType } from '../types/TherapistStateType'
import { createTypedActions } from './redux.utils'

/* ------------- Types and Action Creators ------------- */

const ACTIONS = {
  onChangeOpenTherapistsValue: ['path', 'value'],
  onMergeOpenTherapistsValue: ['value'],
}

const { Types, Creators } = createTypedActions<keyof typeof ACTIONS>(ACTIONS)

// ======================================================
// Middleware Configuration
// ======================================================
const middleware = [thunk]

middleware.push(FetchingMiddleware as any)

const OpenTherapistsActions = Creators
export const OpenTherapistsTypes = Types
export default OpenTherapistsActions

/* ------------- Initial State ------------- */

export const INITIAL_STATE = {
  therapists: [],
}

/* ------------- Reducers ------------- */

export const onChangeOpenTherapistsValueR = (
  state: TherapistStateType,
  { path, value }: { path: string; value: object | string | boolean | number },
): TherapistStateType => assocPath(path.split('.'), value, state)

export const onMergeOpenTherapistsValueR = (
  state: TherapistStateType,
  { value }: { value: object | boolean | number | string },
): TherapistStateType => mergeDeepRight(state, value)

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.ON_CHANGE_OPEN_THERAPISTS_VALUE]: onChangeOpenTherapistsValueR,
  [Types.ON_MERGE_OPEN_THERAPISTS_VALUE]: onMergeOpenTherapistsValueR,
} as any)
